import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameFeedController} from '../../../../shared/scripts/ui_game/ui_game_feed/UIGameFeedController'
import {UIWGameFeedView} from './UIWGameFeedView'
import {UIDGameFeedView} from './UIDGameFeedView'

export class UIWGameFeedController extends UIGameFeedController {
    constructor(uiGameManager: UIGameManager) {
        super(uiGameManager)

        this.view = UIUtilsEjsVariables.isUserOnDiscord ? new UIDGameFeedView(uiGameManager) : new UIWGameFeedView(uiGameManager)
        this.view.gameChat.buttonElement.addEventListener('click', () => {
            this.sendMessageToServer()
        })
        this.bindContainers()
        this.bindOnKeyDown()
        this.setVisibility()
    }

    private setVisibility() {
        this.view.setChatVisibility()
        this.view.gameLog.mainBlock.hidden = false
        this.view.gameChat.mainBlock.hidden = false
        this.resizeChatBox()
    }

    private bindContainers() {
        this.view.gameLog.container.onmouseenter = () => this.preventLogScrollUpdate = true
        this.view.gameLog.container.onmouseleave = () => this.preventLogScrollUpdate = false

        this.view.gameChat.container.onmouseleave = () => this.preventChatScrollUpdate = false
        this.view.gameChat.container.onmouseenter = () => this.preventChatScrollUpdate = true
    }

    private bindOnKeyDown() {
        this.view.gameChat.inputElement.onkeydown = (e) => {
            if(e.key != 'Enter') return
            e.preventDefault()
            this.sendMessageToServer()
        }
    }
}
